
import { AlignType } from "rc-table/lib/interface";

export const searchableTableUtils = {
    alignment: {
        leftAlign: 'center' as AlignType,
        rightAlign: 'center' as AlignType,
        centerAlign: 'center' as AlignType,
    },
}